import { List } from 'immutable';
import moment from 'moment';
import { createSelector } from 'reselect';

import { selectedStructure } from '@sophocles/features/sites/slices/selectedStructure/selectors';

export const dailyInternationalPowerMeterReportSelector = state => state.entities.dailyInternationalPowerMeterReports;

export const getDailyInternationalPowerMeterReportSelector = createSelector(
  dailyInternationalPowerMeterReportSelector,
  reports => reports.map(report => report.toMap().set('moment', moment(report.get('report_date', moment())))),
);

export const getDailyInternationalPowerMeterReportsForSelectedStructure = createSelector(
  selectedStructure,
  getDailyInternationalPowerMeterReportSelector,
  (structure, reports) => {
    if (structure < -1) {
      return List();
    }
    return reports.filter(report => report.get('site', -1) == structure).toList();
  },
);
